<template>
  <div>
    <div class="fb-page"
         :data-href="pageUrl"
         data-tabs="timeline"
         data-width="500"
         data-height="500"
         data-small-header="false"
         data-adapt-container-width="true"
         data-hide-cover="false"
         data-show-facepile="true">
      <blockquote :cite="pageUrl" class="fb-xfbml-parse-ignore">
        <a :href="pageUrl">Facebook</a>
      </blockquote>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacebookPage',
  props: {
    pageUrl: {
      type: String,
      required: true
    }
  },
  mounted() {
    // Re-render Facebook plugins if the SDK is already loaded
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }
}
</script>

<style scoped>
/* Puedes agregar estilos personalizados aquí */
</style>



// WEBPACK FOOTER //
// src/components/FacebookPage.vue